import { ApiEnvironment } from '../../models/api-environment';

export class PcMilerWebServicesEnvironment extends ApiEnvironment {
  avoidFavorSetsSetIdGroupsUrl(setId: number) {
    return `${this.baseUrl}/avoidFavorSets/${setId}/Groups`;
  }

  override resolve(environment: unknown) {
    return environment instanceof PcMilerWebServicesEnvironment
      ? environment
      : this;
  }
}

export const pcMilerWebServicesEnvironment =
  new PcMilerWebServicesEnvironment();
